export const ACTIVITIES = [
    { label: "Gimnasio tradicional", value: 10 },
    { label: "Crossfit", value: 20 },
    { label: "Pilates", value: 30 },
    { label: "Yoga", value: 40 },
    { label: "Fútbol", value: 50 },
    { label: "Béisbol", value: 60 },
    { label: "Basketbol", value: 70 },
    { label: "Ciclismo", value: 80 },
    { label: "Rugby", value: 90 },
    { label: "Boxeo", value: 100 },
    { label: "Tenis", value: 110 },
    { label: "Golf", value: 120 },
    { label: "Patinaje", value: 130 },
    { label: "Volleyball", value: 140 },
    { label: "Atletismo", value: 150 },
    { label: "Natación", value: 160 },
    { label: "Gimnasia", value: 170 },
    { label: "Artes marciales", value: 180 },
    { label: "Otros", value: 190 },
];

export const ADDITIONAL_SERVICES = [
    { name: "nutricion", iconIndex: 1, label: "Asesoría en nutrición", value: 10 },
    { name: "fisio", iconIndex: 2, label: "Servicio de fisioterapia", value: 20 },
    { name: "grupales", iconIndex: 3, label: "Clases grupales", value: 30 },
    { name: "personalizados", iconIndex: 4, label: "Entrenamientos personalizados", value: 40 },
    { name: "chequeos", iconIndex: 5, label: "Chequeos médicos", value: 50 },
    { name: "motivacion", iconIndex: 6, label: "Motivación para atletas", value: 60 },
    { name: "ropa", iconIndex: 7, label: "Venta de ropa y accesorios", value: 70 },
    { name: "otros", iconIndex: 8, label: "Otros", value: 80 },
];

export const TRAINER_OPTIONS = [
    { value: 10, label: "1 - 2" },
    { value: 20, label: "2 - 5" },
    { value: 30, label: "5 - 10" },
    { value: 40, label: "Más de 10" },
];

export const SPECIALTIES = [
    { name: "fuerza", iconIndex: 9, label: "Entrenamiento de fuerza", value: 10 },
    { name: "cardio", iconIndex: 10, label: "Entrenamiento cardiovascular", value: 20 },
    { name: "deportes", iconIndex: 11, label: "Preparación para deportes", value: 30 },
    { name: "acondicionamiento", iconIndex: 12, label: "Acondicionamiento físico", value: 40 },
    { name: "fisio", iconIndex: 13, label: "Fisioterapia deportiva", value: 50 },
    { name: "metabolico", iconIndex: 14, label: "Entrenamiento metabólico", value: 60 },
    { name: "yoga", iconIndex: 15, label: "Yoga y meditación", value: 70 },
    { name: "mayores", iconIndex: 16, label: "Entrenamiento para mayores", value: 80 },
    { name: "coaching", iconIndex: 17, label: "Coaching motivacional", value: 90 },
    { name: "otros", iconIndex: 18, label: "Otros", value: 100 },
];

export const AVAILABILITY_OPTIONS = [
    { name: "Presencial", iconIndex: 19, value: 10 },
    { name: "Virtual", iconIndex: 20, value: 20 },
];

export const METRICS = [
    { name: "Actividad física", iconIndex: 21, value: 10 },
    { name: "Composición corporal", iconIndex: 22, value: 20 },
    { name: "Salud y Bienestar General", iconIndex: 23, value: 30 },
    { name: "Métricas Administrativas", iconIndex: 24, value: 40 },
];
